const DB_NAME = 'fendanacura_offline';
const STORE_NAME = 'sync_queue';

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function queueOfflineAction(action) {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const store = tx.objectStore(STORE_NAME);
  const item = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
    type: action.type,
    data: action.data,
    queued_at: new Date().toISOString()
  };
  store.put(item);
  return new Promise((resolve) => { tx.oncomplete = () => resolve(item.id); });
}

export async function getQueuedActions() {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, 'readonly');
  const store = tx.objectStore(STORE_NAME);
  const request = store.getAll();
  return new Promise((resolve) => { request.onsuccess = () => resolve(request.result); });
}

export async function clearSyncedActions(ids) {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const store = tx.objectStore(STORE_NAME);
  for (const id of ids) {
    store.delete(id);
  }
  return new Promise((resolve) => { tx.oncomplete = () => resolve(); });
}

export async function syncOfflineQueue(apiUrl) {
  if (!navigator.onLine) return { synced: 0, total: 0 };

  const actions = await getQueuedActions();
  if (actions.length === 0) return { synced: 0, total: 0 };

  try {
    const response = await fetch(`${apiUrl}/api/sync/queue`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ actions })
    });

    if (response.ok) {
      const result = await response.json();
      const syncedIds = result.results
        .filter(r => r.status === 'synced')
        .map(r => r.action_id);
      await clearSyncedActions(syncedIds);
      return result;
    }
  } catch (err) {
    console.error('Sync error:', err);
  }

  return { synced: 0, total: actions.length };
}

// Auto-sync when coming back online
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    const apiUrl = process.env.REACT_APP_BACKEND_URL;
    if (apiUrl) {
      syncOfflineQueue(apiUrl).then(result => {
        if (result.synced > 0) {
          console.log(`Synced ${result.synced} offline actions`);
        }
      });
    }
  });
}
